<template>
  <!-- VER PDF -->
  <v-dialog v-model="dialogAsignar.estatus" max-width="400px" persistent>
    <v-card>
    		<v-card-title></v-card-title>
    		<v-card-text class="black--text text-center" >
    			Asignar prospecto a una vendedora
    			<br/>
    			<br/>
    			<br/>

			    <v-autocomplete
	          filled
	          dense
	          clearable
	          v-model="vendedoraUnica"
	          :items="filterVendedoras"
	          label="Selecciona vendedora"
	          hide-details
	          item-text="nombre_plantel"
	          item-value="iderp"
	          return-object
	        >
	        </v-autocomplete>
    		</v-card-text>
    		<v-card-actions>
    			<v-btn 	
    				color="grey" 
    				icon 
    				dark 
    				small 
    				@click="dialogAsignar.estatus = false"
    				absolute
    				top
    				right
    			>
    				<v-icon>mdi-close</v-icon>
    			</v-btn>
    			<v-spacer></v-spacer>
    			<v-btn color="green" block large class="text-capitalize" dark  @click="iniciarReasignacion( )">Sí, seguro</v-btn>
    		</v-card-actions>
    	</v-card>
	  <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>
  </v-dialog>
</template>

<script>
	import axios from 'axios';

	// Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'


	export default {

		components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

		props:[
			'dialogAsignar',
			'alumno',
			'wha',
			'chat'
		],

		data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      cargar: false,

      vendedoras:[],
      vendedoraUnica: null,

		}),

		computed:{
			filterVendedoras( ){
				return this.vendedoras//.filter( el => el.activo_sn == 1)
			}
		},

		created(){

			this.getVendedorasCRM( )

		},

		methods: {
			initialize () {
				this.cargar = true
				this.usuarios = []
				return this.$http.get('whatsapp.usuarios').then(response=>{
					this.usuarios = response.data
					this.cargar      = false
				}).catch( error =>{
					this.validarError( error.response.data.message )
				}).finally( () => { this.cargar = false })
			},

			getVendedorasCRM () {
      	this.cargar = true
        this.vendedoras = []
        return this.$http.get('vendedoras.list').then(response=>{
        	this.vendedoras = response.data

			// Eliminar duplicado por nombre_plantel
			this.vendedoras = this.vendedoras.filter((persona, index, self) =>
				index === self.findIndex((p) => p.nombre_plantel === persona.nombre_plantel)
			);
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      iniciarReasignacion(){

      	// Mandamos los datos completos
      	const payload = {
      		vendedora            : this.vendedora,
					prospectosAReasignar : this.chat,
					opReasigancion       : 2,
					vendedoraUnica       : this.vendedoraUnica
      	}

        
        return this.$http.post('asignar.prospectos.manual', payload ).then(response=>{

        	this.chat['folio'] = response.data.folio


        	this.dialogAsignar.estatus = false
	      	this.prospectosAReasignar = null
	      	this.vendedoraUnica       = null

        	this.validarSuccess('Datos reasignados correctamente')
        	this.dialogAlerta = false
        	this.cargar       = false
        	this.getVendedorasCRM( )
	      	// Agregarmos primero los datos
	      	
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      }
		},
	}
</script>
<style  scoped>


</style>

